import { closeModal } from 'actions/modal';
import { useDispatch } from 'react-redux';

const useLogic = () => {
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(closeModal());
  };

  return {
    handleClose,
  };
};

export default useLogic;
